import { Stack, Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import axiosInstant from "../../../api";
import { BrandCard } from "../../brand/components/BrandCard";
import { WhiteBackground } from "../../../components/WhiteBackground";
import { EmptyPanel } from "../../brand/projects/common/EmptyPanel";
import { MainContainer } from "../../../components/ContentWrapper";
import { DotLottleLoader } from "../../../components/Loader";

interface IBrand {
  id: string;
  logo: string;
  name: string;
}

export function MyProBrands() {
  const [loading, setLoading] = useState(true);
  const [brands, setBrands] = useState<Array<IBrand>>([]);

  const fetchBrands = () => {
    setLoading(true);
    axiosInstant.get("/users/me/brands").then((response) => {
      setBrands(response.data.rows);
      setLoading(false);
    });
  };

  useEffect(fetchBrands, []);

  return (
    <WhiteBackground>
      <MainContainer title="brands">
        <Box className="flex gap-0">
          <Typography className="w-[110px] text-text-2">
            {brands.length} Brands
          </Typography>
          <div className="mt-3 border-t w-full border-border-token" />
        </Box>

        <Stack direction="row" alignItems="top">
          <Box
            height="auto"
            maxWidth="auto"
            flexGrow={1}
            sx={{
              overflow: "visible",
              paddingRight: "16px",
              marginRight: "16px",
              marginTop: 16,
            }}
          >
            <Box
              sx={{
                overflow: "visible",
                marginRight: "-30px",
              }}
            >
              {loading && !brands.length && (
                <DotLottleLoader fill={false} />
              )}
              {!loading && !brands.length && (
                <EmptyPanel
                  title="You have no brands yet."
                  text="Your brands will be shown here once available."
                />
              )}
              {!loading && (
                <div className="my-8 grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                  {brands.map((brand) => (
                    <BrandCard key={brand.id} {...brand}>
                      <div />
                    </BrandCard>
                  ))}
                </div>
              )}
            </Box>
          </Box>
        </Stack>
      </MainContainer>{" "}
    </WhiteBackground>
  );
}
